export enum EventStatus {
  CONFIRMED = 'Confirmé',
  COMPLETED = 'Complété',
  PRESENCE_VALIDATED = 'Présence validée',
  PENDING = 'En attente',
  CANCELLED = 'Annulé',
}

export enum EventFormat {
  ONLINE = 'En ligne',
  PHYSICAL = 'Présentiel',
  HYBRID = 'Hybride',
}

export interface Event {
  id: string;
  title: string;
  description: string;
  date: string; // ISO format
  location: string;
  format: EventFormat;
  status: EventStatus;
  category: string;
  thumbnail?: string;
  price?: number;
  currency?: string;
  documents?: EventDocument[];
  speakers?: EventSpeaker[];
  registrationDeadline?: string;
}

export interface EventDocument {
  id: string;
  name: string;
  url: string;
  size?: string;
  type: string;
}

export interface EventSpeaker {
  id: string;
  name: string;
  role: string;
  avatar?: string;
}

export interface EventRegistration {
  id: string;
  eventId: string;
  userId: string;
  registrationDate: string;
  status: 'confirmed' | 'pending' | 'cancelled' | 'attended';
  feedbackSubmitted?: boolean;
}
